// @ts-nocheck
import * as base from './base/realtime-session';
import * as server from './services/server';

export * from './services/server';


export * from './custom-exports';

export * from './base/realtime-session';
export type SystemCommandParams = base.SystemCommandParams;
export type AggregateCommandParams = base.AggregateCommandParams;
export type BackendConfig = base.BackendConfig;
import type { ExecutionContextProvider } from './base/SSE';

let contextProvider: base.ExecutionContextProvider | undefined;

/** Server calls this at startup to wire ALS context into the client library */
export const setExecutionContextProvider = ( provider: ExecutionContextProvider ) => {
  contextProvider = provider;
};

export const friendlyName = {
  Events: {
    es: {
      CronjobTriggered: 'Cronjob fue disparado',
      OrderStatusChanged: 'Estado de la órden de compra fue cambiado',
      OrderCancelled: 'Órden de compra fue cancelada',
      OrderReturned: 'Órden de compra fue devuelta',
      WarehouseItemAvailableStockDecreased: 'Stock fue modificado por venta',
      WarehouseItemAvailableStockIncreased: 'Stock fue repuesto por devolución',
      WarehouseItemAvailableStockSet: 'Stock fue modificado manualmente',
      OrderPlaced: 'Órden de compra fue iniciada',
      ClientAccountResumed: 'Cuenta de cliente fue reactivada',
      SystemIntegrationCredentialRestored: 'Credencial de integración restablecida',
      BatchProcessFailed: 'Proceso por lotes fallido',
      ExternalProductObserved: 'Producto externo observado',
      ExternalStockObserved: 'Stock externo observado',
      ExternalPriceObserved: 'Precio externo observado',
      PriceListItemPriceChanged: 'El precio de un ítem en la lista de precios cambió',
      AccountEnteredObservation: 'Cuenta entró en modo observación',
      AccountWentLive: 'Cuenta pasó a modo activo',
      WarehouseItemOversold: 'Venta excedió el stock disponible',
      BuyerInvoiceIntentRecorded: 'El comprador respondió sobre la factura',
      ChannelOrderImportBatchProcessStarted: 'Siembra de historial de pedidos del canal iniciada',
      PublicationSyncFromChannelBatchProcessStarted: 'Sincronizacion de publicaciones desde canal iniciada',
      ErpItemImportBatchProcessStarted: 'Importacion de catalogo ERP iniciada',
      ErpStockImportBatchProcessStarted: 'Importacion de stock desde ERP iniciada',
      ErpPriceImportBatchProcessStarted: 'Importacion de precios desde ERP iniciada',
      BillingProfileRegistered: 'Perfil de facturacion fue registrado',
      PaymentMethodAdded: 'Metodo de pago fue agregado',
      PaymentMethodRemoved: 'Metodo de pago fue eliminado',
      DefaultPaymentMethodSet: 'Metodo de pago predeterminado fue establecido',
      BillingProfileUpdated: 'Perfil de facturacion fue actualizado',
      ProductCreated: 'Producto fue creado',
      ProductPublished: 'Producto fue publicado',
      ProductBundleCreated: 'Paquete de productos fue creado',
      RatePlanVersionPublished: 'Version del plan de precios fue publicada',
      ProductArchived: 'Producto fue archivado',
      ProductUnarchived: 'Producto fue desarchivado',
      ProductNameUpdated: 'Nombre del producto fue actualizado',
      ProductChargeTemplatesUpdated: 'Plantillas de cobro del producto fueron actualizadas',
      ProductDeleted: 'Producto fue eliminado',
      BillingAccountRegistered: 'Cuenta de facturacion fue registrada',
      BillingAccountCurrencyChanged: 'Moneda de la cuenta de facturacion fue cambiada',
      ContractAdded: 'Contrato fue agregado',
      LineItemAdded: 'Linea de cargo fue agregada',
      LineItemEdited: 'Linea de cargo fue editada',
      ContractAmended: 'Contrato fue modificado',
      ProductAdded: 'Producto fue agregado al contrato',
      ProductRemoved: 'Producto fue removido del contrato',
      ContractRenewed: 'Contrato fue renovado',
      ContractExpired: 'Contrato expiro',
      ContractCanceled: 'Contrato fue cancelado',
      BillingAccountSubscriptionInvoiceRequested: 'Factura de cuenta de facturacion fue solicitada',
      DraftSubscriptionInvoiceCreated: 'Factura borrador fue creada',
      PublishedSubscriptionInvoiceCreated: 'Factura fue publicada',
      DraftSubscriptionInvoiceCanceled: 'Factura borrador fue cancelada',
      SubscriptionInvoiceBalanceChanged: 'Saldo de la factura fue cambiado',
      SubscriptionInvoicePostingReversed: 'Imputacion de la factura fue revertida',
      SubscriptionInvoiceStandingChanged: 'Estado de la factura fue cambiado',
      SubscriptionInvoiceEmailSent: 'Correo de la factura fue enviado',
      DraftPaymentCreated: 'Pago borrador fue creado',
      PaymentPublished: 'Pago fue publicado',
      DraftPaymentCanceled: 'Pago borrador fue cancelado',
      PaymentCollected: 'Pago fue cobrado',
      PaymentFailed: 'Pago fallo',
      PaymentCanceled: 'Pago fue cancelado',
      PaymentRefundRequested: 'Reembolso de pago fue solicitado',
      PaymentRefundSucceeded: 'Reembolso de pago fue exitoso',
      PaymentRefundFailed: 'Reembolso de pago fallo',
      PaymentReversed: 'Pago fue revertido',
      PaymentRetryTriggered: 'Reintento de pago fue disparado',
      PaymentAppliedToSubscriptionInvoice: 'Pago fue aplicado a una factura',
      PaymentAppliedToDebit: 'Pago fue aplicado a un debito',
      SubscriptionInvoicePaymentUnapplied: 'Aplicacion de pago a factura fue revertida',
      DebitPaymentUnapplied: 'Aplicacion de pago a debito fue revertida',
      CreditCreated: 'Nota de credito fue creada',
      CreditAppliedToSubscriptionInvoice: 'Credito fue aplicado a una factura',
      CreditConsumed: 'Credito fue consumido por completo',
      CreditAppliedToDebit: 'Credito fue aplicado a un debito',
      DebitCreated: 'Nota de debito fue creada',
      DebitBalanceChanged: 'Saldo del debito fue cambiado',
      DebitPostingReversed: 'Imputacion del debito fue revertida',
      GatewayChargeCallbackReceived: 'Respuesta de cobro de pasarela de pago recibida',
      GatewayRefundCallbackReceived: 'Respuesta de reembolso de pasarela de pago recibida',
      GatewayOrphanWebhookReceived: 'Webhook huerfano de pasarela fue recibido',
      DunningProcessStarted: 'Proceso de cobranza fue iniciado',
      DunningPaymentRetryTriggered: 'Reintento de pago fue activado',
      PaymentOverdueEmailTriggered: 'Correo de pago vencido fue activado',
      AccountPausedTriggered: 'Pausa de cuenta fue activada',
      AccountResumedTriggered: 'Reanudacion de cuenta fue activada',
      DunningProcessResolved: 'Proceso de cobranza fue resuelto',
      OrderEdited: 'Órden de compra fue editada',
      FiscalDocumentPdfAttached: 'PDF del comprobante adjuntado',
      ClientAccountCancelled: 'Cuenta de cliente fue cancelada',
      UserProfileUpdated: 'Perfil de usuario fue actualizado',
      UserProfileRemoved: 'Perfil de usuario fue removido',
      UserDataErased: 'Datos del usuario fueron eliminados',
      UserAccountAdded: 'Usuario fue agregado a la cuenta',
      UserAccountRemoved: 'Usuario fue removido de la cuenta',
      AccountDataErased: 'Datos de la cuenta fueron eliminados',
      AccountHoldPlaced: 'Se aplicó una retención a la cuenta de cliente',
      ClientAccountSuspended: 'Cuenta de cliente fue suspendida',
      AccountHoldLifted: 'Se levantó una retención de la cuenta de cliente',
      ConnectorKindEgressModeSet: 'Modo de egreso por tipo de conector configurado',
      DashboardReportChanged: 'Reporte del panel cambiado',
      BillingEntityWizardDismissed: 'Asistente de entidad de facturación descartado',
      BillingEntityWizardCompleted: 'Asistente de entidad de facturación completado',
      BillingEntityWizardReopened: 'Asistente de entidad de facturación reabierto',
      AssignmentGroupCreated: 'Grupo de asignación fue creado',
      AssignmentGroupRenamed: 'Grupo de asignación fue renombrado',
      AssignmentGroupDeleted: 'Grupo de asignación fue eliminado',
      GroupMemberAdded: 'Usuario fue agregado al grupo',
      GroupMemberRemoved: 'Usuario fue removido del grupo',
      SocialLoginCompleted: 'Inicio de sesion social completado',
      InventoryPreferencesChanged: 'Preferencias de inventario cambiadas',
      FeatureFlagCreated: 'Feature flag fue creado',
      FeatureFlagUpdated: 'Feature flag fue actualizado',
      FeatureFlagEnabled: 'Feature flag fue habilitado',
      FeatureFlagDisabled: 'Feature flag fue deshabilitado',
      FeatureFlagArchived: 'Feature flag fue archivado',
      FeatureFlagScheduled: 'Feature flag fue programado',
      CronjobSubscriptionRegistered: 'Suscripcion de cronjob fue registrada',
      CronjobSubscriptionUnregistered: 'Suscripcion de cronjob fue desregistrada',
      AuthUserCreated: 'Usuario de autenticacion fue creado',
      AuthMemberCreated: 'Miembro de autenticacion fue creado',
      AuthMembershipRolesUpdated: 'Roles de membresia actualizados',
      AuthMemberRemoved: 'Miembro de autenticacion fue removido',
      AuthUserPasskeyRegistered: 'Passkey fue registrada',
      AuthUserPasskeyRevoked: 'Passkey fue revocada',
      AuthUserPasswordSet: 'Contrasena del usuario fue establecida',
      AuthUserPasswordChanged: 'Contrasena del usuario fue cambiada',
      AuthUserGroupAssigned: 'Usuario fue asignado a un grupo',
      AuthUserGroupUnassigned: 'Usuario fue desasignado de un grupo',
      CustomRoleDefined: 'Rol personalizado fue definido',
      CustomRoleEdited: 'Rol personalizado fue editado',
      CustomRoleRemoved: 'Rol personalizado fue removido',
      FiscalDocumentIssuanceRequested: 'Emisión de comprobante solicitada',
      BuyerInvoicePreferenceRequested: 'Preferencia de facturación del comprador solicitada',
      BuyerInvoicePreferenceTimedOut: 'Venció el plazo de la preferencia de facturación del comprador',
      BuyerInvoicePreferenceRequestCleared: 'Se anuló la solicitud de preferencia de facturación del comprador',
      BuyerInvoiceIntentRecordedAfterIssuance: 'El comprador respondió sobre la factura después de la emisión',
      FiscalDocumentNumberAssigned: 'Número de comprobante asignado',
      FiscalDocumentAuthorized: 'Comprobante autorizado',
      FiscalDocumentIssuanceFailed: 'Emisión de comprobante falló',
      CreditNoteRequested: 'Nota de crédito solicitada',
      CreditNoteBlocked: 'Nota de crédito bloqueada',
      DebitNoteRequested: 'Nota de débito solicitada',
      CreditNoteIssued: 'Nota de crédito emitida',
      FiscalDocumentIssuanceEnqueued: 'Emisión de comprobante encolada',
      PriceListCreated: 'Lista de precios creada',
      PriceListUpdated: 'Lista de precios actualizada',
      PriceListDeleted: 'Lista de precios eliminada',
      PublicationDelisted: 'Publicación fue dada de baja del canal',
      PublicationRelisted: 'Publicación fue republicada en el canal',
      ExternalPublicationErrored: 'Publicacion externa tuvo un error',
      PublicationDriftClosed: 'Se cerró una discrepancia de canal de la publicación',
      PublicationRepublishRequested: 'Se solicitó republicar la publicación como un aviso nuevo',
      PublicationDriftOpened: 'Se abrió una discrepancia de canal de la publicación',
      ChannelCategoryMapped: 'Categoría de canal mapeada',
      SizeGuideCreated: 'Guía de talle creada',
      SizeGuideUpdated: 'Guía de talle actualizada',
      SizeGuideDeleted: 'Guía de talle eliminada',
      CategorySkuFormulaOverrideSet: 'Formula SKU por categoria fue configurada',
      CategorySkuFormulaOverrideRemoved: 'Formula SKU por categoria fue removida',
      InventoryListPreferencesChanged: 'Preferencias de lista de inventario cambiadas',
      SellerReputationSynced: 'Reputación del vendedor sincronizada',
      ListingVisitsSynced: 'Visitas de publicaciones sincronizadas',
      OperationProposed: 'Operación fue propuesta',
      OperationChangeSetComputed: 'Conjunto de cambios de la operación fue calculado',
      OperationApproved: 'Operación fue aprobada',
      OperationRejected: 'Operación fue rechazada',
      OperationApplyStarted: 'Aplicación de la operación comenzó',
      OperationApplied: 'Operación fue aplicada',
      OperationComputeFailed: 'Cálculo de la operación falló',
      OperationApplyFailed: 'Aplicación de la operación falló',
      SupplierRegistered: 'Proveedor fue registrado',
      SupplierEdited: 'Proveedor fue editado',
      SupplierDeactivated: 'Proveedor fue desactivado',
      SupplierReactivated: 'Proveedor fue reactivado',
      PurchaseOrderIssued: 'Orden de compra fue emitida',
      PurchaseOrderCancelled: 'Orden de compra fue cancelada',
      SupplierSkuMapped: 'SKU de proveedor fue mapeado al articulo',
      SupplierSkuUnmapped: 'SKU de proveedor fue desmapeado del articulo',
      PreferredSupplierSet: 'Proveedor preferido fue establecido',
      PreferredSupplierCleared: 'Proveedor preferido fue quitado',
      OrderCustomerLinked: 'Órden de compra fue vinculada a un cliente',
      ShipmentRegistered: 'Envío fue registrado',
      ShipmentStatusChanged: 'Estado del envío fue cambiado',
      OrderStatusesConfigured: 'Estados de pedido fueron configurados',
      CustomerRegistered: 'Cliente fue registrado',
      CustomerIdentityLinked: 'Identidad del cliente fue vinculada',
      CustomerIdentityCollisionDetected: 'Colisión de identidades de cliente detectada',
      DefaultWarehouseSet: 'Depósito por defecto fue establecido',
      WarehouseAssigneeAdded: 'Depósito fue asignado a un principal',
      WarehouseAssigneeRemoved: 'Asignación del depósito a un principal fue removida',
      SystemIntegrationConnectorProvisioned: 'Conector de integración de sistema provisionado',
      SystemIntegrationConnectorConfigurationUpdated: 'Configuración de conector de integración actualizada',
      SystemIntegrationConnectorStateChanged: 'Estado del conector de integración cambiado',
      SystemIntegrationProvisioned: 'Integración de sistema provisionada',
      SystemIntegrationConfigurationUpdated: 'Configuración de integración de sistema actualizada',
      SystemIntegrationStateChanged: 'Estado de integración de sistema cambiado',
      SystemIntegrationCredentialRevoked: 'Credencial de integración revocada',
      SystemsIntegrationsOperationRequested: 'Operación de integración de sistema solicitada',
      IntegrationAssigneeAdded: 'Integración fue asignada a un principal',
      IntegrationAssigneeRemoved: 'Asignación de la integración a un principal fue removida',
      SystemsIntegrationsElementOperationRequested: 'Operación de elemento de integración de sistema solicitada',
      SystemsIntegrationsWebhookReceived: 'Webhook de integración de sistema recibido',
      ErpBulkImportRequested: 'Importación masiva de catálogo ERP solicitada',
      ErpDriftOpened: 'Divergencia con el ERP detectada',
      ErpDriftClosed: 'Divergencia con el ERP resuelta',
      AccountEmailRequested: 'Email de la cuenta solicitado',
      AccountEmailSent: 'Email de la cuenta enviado',
      AccountEmailSendFailed: 'Envío de email de la cuenta fallido',
      ChannelCategoryRegistered: 'Categoría de canal registrada',
      ChannelCategoryMarkedUnmappable: 'Categoría de canal marcada como no mapeable',
      ChannelCategoryUnmapped: 'Categoría de canal desmapeada',
      ChannelCategoriesResyncRequested: 'Resincronización de categorías solicitada'
    },
    en: {
      CronjobTriggered: 'Cronjob was triggered',
      OrderStatusChanged: 'Order status was changed',
      OrderCancelled: 'Order was cancelled',
      OrderReturned: 'Order was returned',
      WarehouseItemAvailableStockDecreased: 'Stock was updated by sale',
      WarehouseItemAvailableStockIncreased: 'Stock was restocked by return',
      WarehouseItemAvailableStockSet: 'Stock was manually updated',
      OrderPlaced: 'Order was placed',
      ClientAccountResumed: 'Client account was resumed',
      SystemIntegrationCredentialRestored: 'System integration credential restored',
      BatchProcessFailed: 'Batch process failed',
      ExternalProductObserved: 'External product observed',
      ExternalStockObserved: 'External stock observed',
      ExternalPriceObserved: 'External price observed',
      PriceListItemPriceChanged: 'The price of an item in the price list changed',
      AccountEnteredObservation: 'Account entered observation mode',
      AccountWentLive: 'Account went live',
      WarehouseItemOversold: 'Sale exceeded available stock',
      BuyerInvoiceIntentRecorded: 'Buyer invoice intent was recorded',
      ChannelOrderImportBatchProcessStarted: 'Channel order history seeding started',
      PublicationSyncFromChannelBatchProcessStarted: 'Publication sync from channel batch process started',
      ErpItemImportBatchProcessStarted: 'ERP catalog import started',
      ErpStockImportBatchProcessStarted: 'ERP stock import started',
      ErpPriceImportBatchProcessStarted: 'ERP price import started',
      BillingProfileRegistered: 'Billing profile was registered',
      PaymentMethodAdded: 'Payment method was added',
      PaymentMethodRemoved: 'Payment method was removed',
      DefaultPaymentMethodSet: 'Default payment method was set',
      BillingProfileUpdated: 'Billing profile was updated',
      ProductCreated: 'Product was created',
      ProductPublished: 'Product was published',
      ProductBundleCreated: 'Product bundle was created',
      RatePlanVersionPublished: 'Rate plan version was published',
      ProductArchived: 'Product was archived',
      ProductUnarchived: 'Product was unarchived',
      ProductNameUpdated: 'Product name was updated',
      ProductChargeTemplatesUpdated: 'Product charge templates were updated',
      ProductDeleted: 'Product was deleted',
      BillingAccountRegistered: 'Billing account was registered',
      BillingAccountCurrencyChanged: 'Billing account currency was changed',
      ContractAdded: 'Contract was added',
      LineItemAdded: 'Line item was added',
      LineItemEdited: 'Line item was edited',
      ContractAmended: 'Contract was amended',
      ProductAdded: 'Product was added to contract',
      ProductRemoved: 'Product was removed from contract',
      ContractRenewed: 'Contract was renewed',
      ContractExpired: 'Contract expired',
      ContractCanceled: 'Contract was canceled',
      BillingAccountSubscriptionInvoiceRequested: 'Billing account subscriptionInvoice was requested',
      DraftSubscriptionInvoiceCreated: 'Draft subscriptionInvoice was created',
      PublishedSubscriptionInvoiceCreated: 'SubscriptionInvoice was published',
      DraftSubscriptionInvoiceCanceled: 'Draft subscriptionInvoice was canceled',
      SubscriptionInvoiceBalanceChanged: 'SubscriptionInvoice balance was changed',
      SubscriptionInvoicePostingReversed: 'SubscriptionInvoice posting was reversed',
      SubscriptionInvoiceStandingChanged: 'SubscriptionInvoice standing was changed',
      SubscriptionInvoiceEmailSent: 'SubscriptionInvoice email was sent',
      DraftPaymentCreated: 'Draft payment was created',
      PaymentPublished: 'Payment was published',
      DraftPaymentCanceled: 'Draft payment was canceled',
      PaymentCollected: 'Payment was collected',
      PaymentFailed: 'Payment failed',
      PaymentCanceled: 'Payment was canceled',
      PaymentRefundRequested: 'Payment refund was requested',
      PaymentRefundSucceeded: 'Payment refund succeeded',
      PaymentRefundFailed: 'Payment refund failed',
      PaymentReversed: 'Payment was reversed',
      PaymentRetryTriggered: 'Payment retry was triggered',
      PaymentAppliedToSubscriptionInvoice: 'Payment was applied to a subscription invoice',
      PaymentAppliedToDebit: 'Payment was applied to a debit',
      SubscriptionInvoicePaymentUnapplied: 'SubscriptionInvoice payment was unapplied',
      DebitPaymentUnapplied: 'Debit payment was unapplied',
      CreditCreated: 'Credit was created',
      CreditAppliedToSubscriptionInvoice: 'Credit was applied to a subscription invoice',
      CreditConsumed: 'Credit was fully consumed',
      CreditAppliedToDebit: 'Credit was applied to a debit',
      DebitCreated: 'Debit was created',
      DebitBalanceChanged: 'Debit balance was changed',
      DebitPostingReversed: 'Debit posting was reversed',
      GatewayChargeCallbackReceived: 'Payment gateway charge callback received',
      GatewayRefundCallbackReceived: 'Payment gateway refund callback received',
      GatewayOrphanWebhookReceived: 'Orphan gateway webhook was received',
      DunningProcessStarted: 'Dunning process was started',
      DunningPaymentRetryTriggered: 'Payment retry was triggered',
      PaymentOverdueEmailTriggered: 'Payment overdue email was triggered',
      AccountPausedTriggered: 'Account pause was triggered',
      AccountResumedTriggered: 'Account resume was triggered',
      DunningProcessResolved: 'Dunning process was resolved',
      OrderEdited: 'Order was edited',
      FiscalDocumentPdfAttached: 'Invoice PDF was attached',
      ClientAccountCancelled: 'Client account was cancelled',
      UserProfileUpdated: 'User profile was updated',
      UserProfileRemoved: 'User profile was removed',
      UserDataErased: 'User data was erased',
      UserAccountAdded: 'User was added to account',
      UserAccountRemoved: 'User was removed from account',
      AccountDataErased: 'Account data was erased',
      AccountHoldPlaced: 'A hold was placed on the client account',
      ClientAccountSuspended: 'Client account was suspended',
      AccountHoldLifted: 'A hold was lifted from the client account',
      ConnectorKindEgressModeSet: 'Connector-kind egress mode set',
      DashboardReportChanged: 'Dashboard report changed',
      BillingEntityWizardDismissed: 'Billing entity wizard dismissed',
      BillingEntityWizardCompleted: 'Billing entity wizard completed',
      BillingEntityWizardReopened: 'Billing entity wizard reopened',
      AssignmentGroupCreated: 'Assignment group was created',
      AssignmentGroupRenamed: 'Assignment group was renamed',
      AssignmentGroupDeleted: 'Assignment group was deleted',
      GroupMemberAdded: 'User was added to group',
      GroupMemberRemoved: 'User was removed from group',
      SocialLoginCompleted: 'Social login completed',
      InventoryPreferencesChanged: 'Inventory preferences changed',
      FeatureFlagCreated: 'Feature flag was created',
      FeatureFlagUpdated: 'Feature flag was updated',
      FeatureFlagEnabled: 'Feature flag was enabled',
      FeatureFlagDisabled: 'Feature flag was disabled',
      FeatureFlagArchived: 'Feature flag was archived',
      FeatureFlagScheduled: 'Feature flag was scheduled',
      CronjobSubscriptionRegistered: 'Cronjob subscription was registered',
      CronjobSubscriptionUnregistered: 'Cronjob subscription was unregistered',
      AuthUserCreated: 'Auth user was created',
      AuthMemberCreated: 'Auth member was created',
      AuthMembershipRolesUpdated: 'Membership roles updated',
      AuthMemberRemoved: 'Auth member was removed',
      AuthUserPasskeyRegistered: 'Passkey was registered',
      AuthUserPasskeyRevoked: 'Passkey was revoked',
      AuthUserPasswordSet: 'User password was set',
      AuthUserPasswordChanged: 'User password was changed',
      AuthUserGroupAssigned: 'User was assigned to a group',
      AuthUserGroupUnassigned: 'User was unassigned from a group',
      CustomRoleDefined: 'Custom role was defined',
      CustomRoleEdited: 'Custom role was edited',
      CustomRoleRemoved: 'Custom role was removed',
      FiscalDocumentIssuanceRequested: 'Billing invoice issuance was requested',
      BuyerInvoicePreferenceRequested: 'Buyer invoice preference was requested',
      BuyerInvoicePreferenceTimedOut: 'Buyer invoice preference timed out',
      BuyerInvoicePreferenceRequestCleared: 'Buyer invoice preference request was cleared',
      BuyerInvoiceIntentRecordedAfterIssuance: 'Buyer invoice intent was recorded after issuance',
      FiscalDocumentNumberAssigned: 'Billing invoice number was assigned',
      FiscalDocumentAuthorized: 'Billing invoice was authorized',
      FiscalDocumentIssuanceFailed: 'Billing invoice issuance failed',
      CreditNoteRequested: 'Credit note was requested',
      CreditNoteBlocked: 'Credit note was blocked',
      DebitNoteRequested: 'Debit note was requested',
      CreditNoteIssued: 'Credit note was issued',
      FiscalDocumentIssuanceEnqueued: 'Invoice issuance was enqueued',
      PriceListCreated: 'Price list created',
      PriceListUpdated: 'Price list updated',
      PriceListDeleted: 'Price list deleted',
      PublicationDelisted: 'Publication was delisted from the channel',
      PublicationRelisted: 'Publication was relisted on the channel',
      ExternalPublicationErrored: 'External publication errored',
      PublicationDriftClosed: 'Publication channel drift closed',
      PublicationRepublishRequested: 'Publication republish as a new listing was requested',
      PublicationDriftOpened: 'Publication channel drift opened',
      ChannelCategoryMapped: 'Channel category mapped',
      SizeGuideCreated: 'Size guide created',
      SizeGuideUpdated: 'Size guide updated',
      SizeGuideDeleted: 'Size guide deleted',
      CategorySkuFormulaOverrideSet: 'Category SKU formula override was set',
      CategorySkuFormulaOverrideRemoved: 'Category SKU formula override was removed',
      InventoryListPreferencesChanged: 'Inventory list preferences changed',
      SellerReputationSynced: 'Seller reputation synced',
      ListingVisitsSynced: 'Listing visits synced',
      OperationProposed: 'Operation was proposed',
      OperationChangeSetComputed: 'Operation change set was computed',
      OperationApproved: 'Operation was approved',
      OperationRejected: 'Operation was rejected',
      OperationApplyStarted: 'Operation apply started',
      OperationApplied: 'Operation was applied',
      OperationComputeFailed: 'Operation compute failed',
      OperationApplyFailed: 'Operation apply failed',
      SupplierRegistered: 'Supplier was registered',
      SupplierEdited: 'Supplier was edited',
      SupplierDeactivated: 'Supplier was deactivated',
      SupplierReactivated: 'Supplier was reactivated',
      PurchaseOrderIssued: 'Purchase order was issued',
      PurchaseOrderCancelled: 'Purchase order was cancelled',
      SupplierSkuMapped: 'Supplier SKU was mapped to the item',
      SupplierSkuUnmapped: 'Supplier SKU was unmapped from the item',
      PreferredSupplierSet: 'Preferred supplier was set',
      PreferredSupplierCleared: 'Preferred supplier was cleared',
      OrderCustomerLinked: 'Order was linked to a customer',
      ShipmentRegistered: 'Shipment was registered',
      ShipmentStatusChanged: 'Shipment status was changed',
      OrderStatusesConfigured: 'Order statuses were configured',
      CustomerRegistered: 'Customer was registered',
      CustomerIdentityLinked: 'Customer identity was linked',
      CustomerIdentityCollisionDetected: 'Customer identity collision was detected',
      DefaultWarehouseSet: 'Default warehouse was set',
      WarehouseAssigneeAdded: 'Warehouse was assigned to a principal',
      WarehouseAssigneeRemoved: 'Warehouse assignment to a principal was removed',
      SystemIntegrationConnectorProvisioned: 'System integration connector provisioned',
      SystemIntegrationConnectorConfigurationUpdated: 'System integration connector configuration updated',
      SystemIntegrationConnectorStateChanged: 'System integration connector state changed',
      SystemIntegrationProvisioned: 'System integration provisioned',
      SystemIntegrationConfigurationUpdated: 'System integration configuration updated',
      SystemIntegrationStateChanged: 'System integration state changed',
      SystemIntegrationCredentialRevoked: 'System integration credential revoked',
      SystemsIntegrationsOperationRequested: 'Systems integrations operation requested',
      IntegrationAssigneeAdded: 'Integration was assigned to a principal',
      IntegrationAssigneeRemoved: 'Integration assignment to a principal was removed',
      SystemsIntegrationsElementOperationRequested: 'Systems integrations element operation requested',
      SystemsIntegrationsWebhookReceived: 'Systems integrations webhook received',
      ErpBulkImportRequested: 'ERP bulk catalog import requested',
      ErpDriftOpened: 'ERP drift opened',
      ErpDriftClosed: 'ERP drift closed',
      AccountEmailRequested: 'Account email requested',
      AccountEmailSent: 'Account email sent',
      AccountEmailSendFailed: 'Account email send failed',
      ChannelCategoryRegistered: 'Channel category registered',
      ChannelCategoryMarkedUnmappable: 'Channel category marked unmappable',
      ChannelCategoryUnmapped: 'Channel category unmapped',
      ChannelCategoriesResyncRequested: 'Channel categories resync requested'
    },
    pt: {
      CronjobTriggered: 'Cronjob foi disparado',
      OrderStatusChanged: 'Estado da ordem de compra foi alterado',
      OrderCancelled: 'Ordem de compra foi cancelada',
      OrderReturned: 'Ordem de compra foi devolvida',
      WarehouseItemAvailableStockDecreased: 'Stock foi modificado por venda',
      WarehouseItemAvailableStockIncreased: 'Stock foi reposto por devolução',
      WarehouseItemAvailableStockSet: 'Stock foi modificado manualmente',
      OrderPlaced: 'Ordem de compra foi iniciada',
      ClientAccountResumed: 'Conta do cliente foi reativada',
      SystemIntegrationCredentialRestored: 'Credencial da integração restabelecida',
      BatchProcessFailed: 'Processo em lote falhou',
      ExternalProductObserved: 'Produto externo observado',
      ExternalStockObserved: 'Stock externo observado',
      ExternalPriceObserved: 'Preço externo observado',
      PriceListItemPriceChanged: 'O preço de um item na lista de preços mudou',
      AccountEnteredObservation: 'Conta entrou em modo de observação',
      AccountWentLive: 'Conta passou para o modo ativo',
      WarehouseItemOversold: 'Venda excedeu o stock disponível',
      BuyerInvoiceIntentRecorded: 'A intenção de faturamento do comprador foi registrada',
      ChannelOrderImportBatchProcessStarted: 'Semeadura de historico de pedidos do canal iniciada',
      PublicationSyncFromChannelBatchProcessStarted: 'Sincronizacao de publicacoes do canal iniciada',
      ErpItemImportBatchProcessStarted: 'Importacao de catalogo ERP iniciada',
      ErpStockImportBatchProcessStarted: 'Importacao de estoque do ERP iniciada',
      ErpPriceImportBatchProcessStarted: 'Importacao de precos do ERP iniciada',
      BillingProfileRegistered: 'Perfil de faturamento foi registrado',
      PaymentMethodAdded: 'Metodo de pagamento foi adicionado',
      PaymentMethodRemoved: 'Metodo de pagamento foi removido',
      DefaultPaymentMethodSet: 'Metodo de pagamento padrao foi definido',
      BillingProfileUpdated: 'Perfil de faturamento foi atualizado',
      ProductCreated: 'Produto foi criado',
      ProductPublished: 'Produto foi publicado',
      ProductBundleCreated: 'Pacote de produtos foi criado',
      RatePlanVersionPublished: 'Versao do plano de precos foi publicada',
      ProductArchived: 'Produto foi arquivado',
      ProductUnarchived: 'Produto foi desarquivado',
      ProductNameUpdated: 'Nome do produto foi atualizado',
      ProductChargeTemplatesUpdated: 'Modelos de cobrança do produto foram atualizados',
      ProductDeleted: 'Produto foi excluído',
      BillingAccountRegistered: 'Conta de faturamento foi registrada',
      BillingAccountCurrencyChanged: 'Moeda da conta de faturamento foi alterada',
      ContractAdded: 'Contrato foi adicionado',
      LineItemAdded: 'Item de cobranca foi adicionado',
      LineItemEdited: 'Item de cobranca foi editado',
      ContractAmended: 'Contrato foi modificado',
      ProductAdded: 'Produto foi adicionado ao contrato',
      ProductRemoved: 'Produto foi removido do contrato',
      ContractRenewed: 'Contrato foi renovado',
      ContractExpired: 'Contrato expirou',
      ContractCanceled: 'Contrato foi cancelado',
      BillingAccountSubscriptionInvoiceRequested: 'Fatura da conta de faturamento foi solicitada',
      DraftSubscriptionInvoiceCreated: 'Fatura rascunho foi criada',
      PublishedSubscriptionInvoiceCreated: 'Fatura foi publicada',
      DraftSubscriptionInvoiceCanceled: 'Fatura rascunho foi cancelada',
      SubscriptionInvoiceBalanceChanged: 'Saldo da fatura foi alterado',
      SubscriptionInvoicePostingReversed: 'Lancamento da fatura foi revertido',
      SubscriptionInvoiceStandingChanged: 'Situacao da fatura foi alterada',
      SubscriptionInvoiceEmailSent: 'E-mail da fatura foi enviado',
      DraftPaymentCreated: 'Pagamento rascunho foi criado',
      PaymentPublished: 'Pagamento foi publicado',
      DraftPaymentCanceled: 'Pagamento rascunho foi cancelado',
      PaymentCollected: 'Pagamento foi cobrado',
      PaymentFailed: 'Pagamento falhou',
      PaymentCanceled: 'Pagamento foi cancelado',
      PaymentRefundRequested: 'Reembolso de pagamento foi solicitado',
      PaymentRefundSucceeded: 'Reembolso de pagamento foi bem-sucedido',
      PaymentRefundFailed: 'Reembolso de pagamento falhou',
      PaymentReversed: 'Pagamento foi revertido',
      PaymentRetryTriggered: 'Nova tentativa de pagamento foi disparada',
      PaymentAppliedToSubscriptionInvoice: 'Pagamento foi aplicado a uma fatura',
      PaymentAppliedToDebit: 'Pagamento foi aplicado a um debito',
      SubscriptionInvoicePaymentUnapplied: 'Aplicacao de pagamento a fatura foi revertida',
      DebitPaymentUnapplied: 'Aplicacao de pagamento a debito foi revertida',
      CreditCreated: 'Nota de credito foi criada',
      CreditAppliedToSubscriptionInvoice: 'Credito foi aplicado a uma fatura',
      CreditConsumed: 'Credito foi totalmente consumido',
      CreditAppliedToDebit: 'Credito foi aplicado a um debito',
      DebitCreated: 'Nota de debito foi criada',
      DebitBalanceChanged: 'Saldo do debito foi alterado',
      DebitPostingReversed: 'Lancamento do debito foi revertido',
      GatewayChargeCallbackReceived: 'Resposta de cobrança da gateway de pagamento recebida',
      GatewayRefundCallbackReceived: 'Resposta de reembolso da gateway de pagamento recebida',
      GatewayOrphanWebhookReceived: 'Webhook orfao da gateway foi recebido',
      DunningProcessStarted: 'Processo de cobranca foi iniciado',
      DunningPaymentRetryTriggered: 'Nova tentativa de pagamento foi acionada',
      PaymentOverdueEmailTriggered: 'E-mail de pagamento vencido foi acionado',
      AccountPausedTriggered: 'Pausa da conta foi acionada',
      AccountResumedTriggered: 'Retomada da conta foi acionada',
      DunningProcessResolved: 'Processo de cobranca foi resolvido',
      OrderEdited: 'Ordem de compra foi editada',
      FiscalDocumentPdfAttached: 'PDF do comprovante foi anexado',
      ClientAccountCancelled: 'Conta do cliente foi cancelada',
      UserProfileUpdated: 'Perfil de usuario foi atualizado',
      UserProfileRemoved: 'Perfil de usuario foi removido',
      UserDataErased: 'Dados do usuario foram apagados',
      UserAccountAdded: 'Usuario foi adicionado a conta',
      UserAccountRemoved: 'Usuario foi removido da conta',
      AccountDataErased: 'Dados da conta foram apagados',
      AccountHoldPlaced: 'Foi aplicada uma retenção à conta do cliente',
      ClientAccountSuspended: 'Conta do cliente foi suspensa',
      AccountHoldLifted: 'Foi removida uma retenção da conta do cliente',
      ConnectorKindEgressModeSet: 'Modo de egresso por tipo de conector configurado',
      DashboardReportChanged: 'Relatório do painel alterado',
      BillingEntityWizardDismissed: 'Assistente de entidade de faturamento descartado',
      BillingEntityWizardCompleted: 'Assistente de entidade de faturamento concluído',
      BillingEntityWizardReopened: 'Assistente de entidade de faturamento reaberto',
      AssignmentGroupCreated: 'Grupo de atribuição foi criado',
      AssignmentGroupRenamed: 'Grupo de atribuição foi renomeado',
      AssignmentGroupDeleted: 'Grupo de atribuição foi excluído',
      GroupMemberAdded: 'Usuário foi adicionado ao grupo',
      GroupMemberRemoved: 'Usuário foi removido do grupo',
      SocialLoginCompleted: 'Login social concluido',
      InventoryPreferencesChanged: 'Preferências de inventário alteradas',
      FeatureFlagCreated: 'Feature flag foi criado',
      FeatureFlagUpdated: 'Feature flag foi atualizado',
      FeatureFlagEnabled: 'Feature flag foi habilitado',
      FeatureFlagDisabled: 'Feature flag foi desabilitado',
      FeatureFlagArchived: 'Feature flag foi arquivado',
      FeatureFlagScheduled: 'Feature flag foi agendado',
      CronjobSubscriptionRegistered: 'Assinatura de cronjob foi registrada',
      CronjobSubscriptionUnregistered: 'Assinatura de cronjob foi cancelada',
      AuthUserCreated: 'Usuario de autenticacao foi criado',
      AuthMemberCreated: 'Membro de autenticacao foi criado',
      AuthMembershipRolesUpdated: 'Funcoes de associacao atualizadas',
      AuthMemberRemoved: 'Membro de autenticacao foi removido',
      AuthUserPasskeyRegistered: 'Passkey foi registrada',
      AuthUserPasskeyRevoked: 'Passkey foi revogada',
      AuthUserPasswordSet: 'Senha do usuario foi definida',
      AuthUserPasswordChanged: 'Senha do usuario foi alterada',
      AuthUserGroupAssigned: 'Usuario foi atribuido a um grupo',
      AuthUserGroupUnassigned: 'Usuario foi desatribuido de um grupo',
      CustomRoleDefined: 'Papel personalizado foi definido',
      CustomRoleEdited: 'Papel personalizado foi editado',
      CustomRoleRemoved: 'Papel personalizado foi removido',
      FiscalDocumentIssuanceRequested: 'Emissão de comprovante foi solicitada',
      BuyerInvoicePreferenceRequested: 'Preferência de faturamento do comprador foi solicitada',
      BuyerInvoicePreferenceTimedOut: 'O prazo da preferência de faturamento do comprador expirou',
      BuyerInvoicePreferenceRequestCleared: 'A solicitação de preferência de faturamento do comprador foi anulada',
      BuyerInvoiceIntentRecordedAfterIssuance: 'A intenção de faturamento do comprador foi registrada após a emissão',
      FiscalDocumentNumberAssigned: 'Número de comprovante foi atribuído',
      FiscalDocumentAuthorized: 'Comprovante foi autorizado',
      FiscalDocumentIssuanceFailed: 'Emissão de comprovante falhou',
      CreditNoteRequested: 'Nota de crédito foi solicitada',
      CreditNoteBlocked: 'Nota de crédito foi bloqueada',
      DebitNoteRequested: 'Nota de débito foi solicitada',
      CreditNoteIssued: 'Nota de crédito foi emitida',
      FiscalDocumentIssuanceEnqueued: 'Emissão de comprovante foi enfileirada',
      PriceListCreated: 'Lista de preços criada',
      PriceListUpdated: 'Lista de preços atualizada',
      PriceListDeleted: 'Lista de preços excluída',
      PublicationDelisted: 'Publicação foi removida do canal',
      PublicationRelisted: 'Publicação foi republicada no canal',
      ExternalPublicationErrored: 'Publicacao externa teve um erro',
      PublicationDriftClosed: 'Fechou-se uma divergência de canal da publicação',
      PublicationRepublishRequested: 'Foi solicitada a republicação da publicação como um novo anúncio',
      PublicationDriftOpened: 'Abriu-se uma divergência de canal da publicação',
      ChannelCategoryMapped: 'Categoria de canal mapeada',
      SizeGuideCreated: 'Guia de tamanhos criado',
      SizeGuideUpdated: 'Guia de tamanhos atualizado',
      SizeGuideDeleted: 'Guia de tamanhos excluído',
      CategorySkuFormulaOverrideSet: 'Formula SKU por categoria foi configurada',
      CategorySkuFormulaOverrideRemoved: 'Formula SKU por categoria foi removida',
      InventoryListPreferencesChanged: 'Preferências de lista de inventário alteradas',
      SellerReputationSynced: 'Reputação do vendedor sincronizada',
      ListingVisitsSynced: 'Visitas de anúncios sincronizadas',
      OperationProposed: 'Operação foi proposta',
      OperationChangeSetComputed: 'Conjunto de alterações da operação foi calculado',
      OperationApproved: 'Operação foi aprovada',
      OperationRejected: 'Operação foi rejeitada',
      OperationApplyStarted: 'Aplicação da operação começou',
      OperationApplied: 'Operação foi aplicada',
      OperationComputeFailed: 'Cálculo da operação falhou',
      OperationApplyFailed: 'Aplicação da operação falhou',
      SupplierRegistered: 'Fornecedor foi registrado',
      SupplierEdited: 'Fornecedor foi editado',
      SupplierDeactivated: 'Fornecedor foi desativado',
      SupplierReactivated: 'Fornecedor foi reativado',
      PurchaseOrderIssued: 'Ordem de compra foi emitida',
      PurchaseOrderCancelled: 'Ordem de compra foi cancelada',
      SupplierSkuMapped: 'SKU do fornecedor foi mapeado ao item',
      SupplierSkuUnmapped: 'SKU do fornecedor foi desmapeado do item',
      PreferredSupplierSet: 'Fornecedor preferido foi definido',
      PreferredSupplierCleared: 'Fornecedor preferido foi removido',
      OrderCustomerLinked: 'Ordem de compra foi vinculada a um cliente',
      ShipmentRegistered: 'Envio foi registrado',
      ShipmentStatusChanged: 'Estado do envio foi alterado',
      OrderStatusesConfigured: 'Estados de pedido foram configurados',
      CustomerRegistered: 'Cliente foi registrado',
      CustomerIdentityLinked: 'Identidade do cliente foi vinculada',
      CustomerIdentityCollisionDetected: 'Colisão de identidades de cliente detectada',
      DefaultWarehouseSet: 'Depósito padrão foi definido',
      WarehouseAssigneeAdded: 'Depósito foi atribuído a um principal',
      WarehouseAssigneeRemoved: 'Atribuição do depósito a um principal foi removida',
      SystemIntegrationConnectorProvisioned: 'Conector de integração de sistema provisionado',
      SystemIntegrationConnectorConfigurationUpdated: 'Configuração do conector de integração atualizada',
      SystemIntegrationConnectorStateChanged: 'Estado do conector de integração alterado',
      SystemIntegrationProvisioned: 'Integração de sistema provisionada',
      SystemIntegrationConfigurationUpdated: 'Configuração da integração de sistema atualizada',
      SystemIntegrationStateChanged: 'Estado da integração de sistema alterado',
      SystemIntegrationCredentialRevoked: 'Credencial da integração revogada',
      SystemsIntegrationsOperationRequested: 'Operação de integração de sistema solicitada',
      IntegrationAssigneeAdded: 'Integração foi atribuída a um principal',
      IntegrationAssigneeRemoved: 'Atribuição da integração a um principal foi removida',
      SystemsIntegrationsElementOperationRequested: 'Operação de elemento de integração de sistema solicitada',
      SystemsIntegrationsWebhookReceived: 'Webhook de integração de sistema recebido',
      ErpBulkImportRequested: 'Importação em massa do catálogo ERP solicitada',
      ErpDriftOpened: 'Divergência com o ERP detectada',
      ErpDriftClosed: 'Divergência com o ERP resolvida',
      AccountEmailRequested: 'E-mail da conta solicitado',
      AccountEmailSent: 'E-mail da conta enviado',
      AccountEmailSendFailed: 'Envio de e-mail da conta falhou',
      ChannelCategoryRegistered: 'Categoria de canal registrada',
      ChannelCategoryMarkedUnmappable: 'Categoria de canal marcada como não mapeável',
      ChannelCategoryUnmapped: 'Categoria de canal desmapeada',
      ChannelCategoriesResyncRequested: 'Ressincronização de categorias solicitada'
    }
  }
};


export type ClientLibraryType = {
  setToken: ( token: string ) => void;
} & ReturnType<typeof base.getCustomExports> & {
  commands: ReturnType<typeof server.create>[ 'commands' ];
  delete: ReturnType<typeof server.create>[ 'delete' ];
  get: ReturnType<typeof server.create>[ 'get' ];
  post: ReturnType<typeof server.create>[ 'post' ];
  queries: ReturnType<typeof server.create>[ 'queries' ];
  subscriptions: ReturnType<typeof server.create>[ 'subscriptions' ];
};
export const create = ( params: BackendConfig, fetch?: any, headers?: Record<string, string | undefined>, _contextProvider?: ExecutionContextProvider ): ClientLibraryType => {
  const cp = _contextProvider ?? contextProvider; // fall back to module-level
  const req = base.requests( params, fetch, headers, cp );
  const serverInstance = server.create( params, fetch, headers, cp );

  const setToken = ( token: string ) => {
    req.setBearerToken( token );
    serverInstance.setBearerToken( token );
  };

  return {
    setToken,
    ...base.getCustomExports(),
    get commands() { return { ...serverInstance.commands }; },
    get delete() { return { ...serverInstance.delete }; },
    get get() { return { ...serverInstance.get }; },
    get post() { return { ...serverInstance.post }; },
    get queries() { return { ...serverInstance.queries }; },
    get subscriptions() { return { ...serverInstance.subscriptions }; }
  };
};